import { createAction } from '@reduxjs/toolkit';

export const persistUserSessionStart = createAction('PERSIST_USER_SESSION::START');
